'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function (Devices) {
  Devices["MOBILE"] = "Mobile";
  Devices["DESKTOP"] = "Desktop";
})(exports.Devices || (exports.Devices = {}));
(function (TreeNodeTypes) {
  TreeNodeTypes["VIEW"] = "View";
  TreeNodeTypes["ROW"] = "Row";
  TreeNodeTypes["COL"] = "Col";
  TreeNodeTypes["FEATURE"] = "Feature";
  TreeNodeTypes["STACK"] = "Stack";
})(exports.TreeNodeTypes || (exports.TreeNodeTypes = {}));
(function (FeatureLayout) {
  FeatureLayout["PORTRAIT"] = "PORTRAIT";
  FeatureLayout["LANDSCAPE"] = "LANDSCAPE";
})(exports.FeatureLayout || (exports.FeatureLayout = {}));
(function (ConditionType) {
  ConditionType["SHIPMENT_STATUS"] = "SHIPMENT_STATUS";
  ConditionType["CARRIER_MONIKER"] = "CARRIER_MONIKER";
  ConditionType["CATEGORY"] = "CATEGORY";
})(exports.ConditionType || (exports.ConditionType = {}));
(function (ConditionOperator) {
  ConditionOperator["EQ"] = "EQ";
  ConditionOperator["NEQ"] = "NEQ";
  ConditionOperator["IN"] = "IN";
})(exports.ConditionOperator || (exports.ConditionOperator = {}));

// Default status for a track page. This is just a fail safe. Actual
// setting of a "default tracking status" is done further upstream
(function (ShipmentStatusConditionStatus) {
  ShipmentStatusConditionStatus["JUSTSHIPPED"] = "JUSTSHIPPED";
  ShipmentStatusConditionStatus["INTRANSIT"] = "INTRANSIT";
  ShipmentStatusConditionStatus["DELIVERED"] = "DELIVERED";
  ShipmentStatusConditionStatus["EXCEPTION"] = "EXCEPTION";
  ShipmentStatusConditionStatus["PROCESSING"] = "PROCESSING";
  ShipmentStatusConditionStatus["PRESHIPMENT0"] = "PRESHIPMENT0";
  ShipmentStatusConditionStatus["PRESHIPMENT1"] = "PRESHIPMENT1";
  ShipmentStatusConditionStatus["PRESHIPMENT2"] = "PRESHIPMENT2";
  ShipmentStatusConditionStatus["PRESHIPMENT3"] = "PRESHIPMENT3";
  ShipmentStatusConditionStatus["PRESHIPMENT4"] = "PRESHIPMENT4";
  ShipmentStatusConditionStatus["PRESHIPMENT5"] = "PRESHIPMENT5";
  ShipmentStatusConditionStatus["PRESHIPMENT6"] = "PRESHIPMENT6";
  ShipmentStatusConditionStatus["PRESHIPMENT7"] = "PRESHIPMENT7";
  ShipmentStatusConditionStatus["PRESHIPMENT8"] = "PRESHIPMENT8";
  ShipmentStatusConditionStatus["PRESHIPMENT9"] = "PRESHIPMENT9";
  ShipmentStatusConditionStatus["BOPISPROCESSING"] = "BOPISPROCESSING";
  ShipmentStatusConditionStatus["BOPISDELAYED"] = "BOPISDELAYED";
  ShipmentStatusConditionStatus["BOPISREADYFORPICKUP"] = "BOPISREADYFORPICKUP";
  ShipmentStatusConditionStatus["BOPISPICKEDUP"] = "BOPISPICKEDUP";
  ShipmentStatusConditionStatus["BOPISCANCELLED"] = "BOPISCANCELED";
  ShipmentStatusConditionStatus["LDORDERPLACED"] = "LDORDERPLACED";
  ShipmentStatusConditionStatus["LDPICKUPINPROGRESS"] = "LDPICKUPINPROGRESS";
  ShipmentStatusConditionStatus["LDONITSWAY"] = "LDONITSWAY";
  ShipmentStatusConditionStatus["LDDELIVERED"] = "LDDELIVERED";
  ShipmentStatusConditionStatus["LDEXCEPTION"] = "LDEXCEPTION";
  ShipmentStatusConditionStatus["HPUSCHEDULED"] = "HPUSCHEDULED";
  ShipmentStatusConditionStatus["HPUPICKUPINPROGRESS"] = "HPUPICKUPINPROGRESS";
  ShipmentStatusConditionStatus["HPUPICKEDUP"] = "HPUPICKEDUP";
  ShipmentStatusConditionStatus["HPUEXCEPTION"] = "HPUEXCEPTION";
})(exports.ShipmentStatusConditionStatus || (exports.ShipmentStatusConditionStatus = {}));
var DEFAULT_NARVAR_STATUS = exports.ShipmentStatusConditionStatus.JUSTSHIPPED;
(function (CarrierConditionMoniker) {
  CarrierConditionMoniker["UPS"] = "ups";
  CarrierConditionMoniker["FEDEX"] = "fedex";
  CarrierConditionMoniker["METRO"] = "metro";
  CarrierConditionMoniker["PILOT"] = "pilot";
})(exports.CarrierConditionMoniker || (exports.CarrierConditionMoniker = {}));
(function (CategoryConditionCategory) {
  CategoryConditionCategory["SHARING"] = "sharing";
})(exports.CategoryConditionCategory || (exports.CategoryConditionCategory = {}));

exports.DEFAULT_NARVAR_STATUS = DEFAULT_NARVAR_STATUS;
